import React, { FC } from 'react';
import { List } from 'antd';
import { useIsFetching } from 'react-query';

import ApprovedReviewList from './ApprovedReviews';

interface Props {
    reviews?: Pagination<Review>;
    gameId?: string;
}

const ApprovedReviews: FC<Props> = ({ gameId, reviews }) => {
    const isFetching = useIsFetching(['approvedReview', gameId], { exact: true });

    return (
        <div>
            <List
                loading={!!isFetching}
                className="comment-list"
                header={`${reviews?.total || 0} reviews`}
                itemLayout="horizontal"
                dataSource={reviews && reviews?.data}
                locale={{ emptyText: <h1 style={{ fontSize: '15px' }}>No Approved Reviews</h1> }}
                renderItem={(item: any) => <ApprovedReviewList data={item} />}
            />
        </div>
    );
};

export default ApprovedReviews;
